//shoptet.cookie.create('debugTimestamp', 1, {days: 100});
var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');
console.log("test");
var trident = ua.indexOf('Trident/');
if (msie > 0 || trident > 0) {
  alert("Internet Explorer nie jest obsługiwany. Prosimy o skorzystanie z nowoczesnej alternatywy, takiej jak Google Chrome itp. Dziękujemy za zrozumienie.");
}
if ($('.breadcrumbs').length) {
  var findlast = $('.breadcrumbs span').last().text();
  var findlast = findlast.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
}

if ($('.serviselektrokol').length) {
  $('footer#footer .serviselektrokol').appendTo('.formularservisu');
  // $('<div id="zobrazit"><input type="submit" value="zobraz"></div>').insertBefore('.formularservisu');
  $("html").on("submit", "#formContact.formularservisu", function () {
    // $('#zobrazit input').on("click", function() {


    originalRemark = $('textarea.form-control').val();
    mhjmeno = $('#fullName').val();
    mhadresa = $('#adress').val();
    mhemail = $('#email').val();
    mhtelefon = $('#phone').val();
    mhtermin = $('#termin').val();
    mhznackaelektrokola = $('#znacka').val();
    mhzavada = $('#zavada').val();
    mhpoznamka = $('#poznamka').val();


    pkNewRemark = 'Imię i nazwisko: ' + mhjmeno + '    ------\nTelefon: ' + mhtelefon + '    ------\nE-mail: ' + mhemail + '    ------\nAdres: ' + mhadresa + '    ------\nTermin: ' + mhtermin + '    ------\nMarka roweru elektrycznego: ' + mhznackaelektrokola + ' ------\nUsterka: ' + mhzavada + ' -------\nUwaga: ' + mhpoznamka;
    $("textarea.form-control").val(pkNewRemark);


  });

};

if ($('.faq').length) {
  // Code By Webdevtrick ( https://webdevtrick.com )
  const items = document.querySelectorAll(".faq h3");

  function toggleAccordion() {
    this.nextElementSibling.classList.toggle('active');
  }

  items.forEach(item => item.addEventListener('click', toggleAccordion));

}

if ($('.type-detail').length) {

  if ($('.p-info-wrapper .detail-parameters .variant-list').length) {
    $('.availability-value>span').each(function () {
      if ($(this).find('.availability-amount .product-stock-amount').length) {
        var finddata = $(this).find('.availability-amount .product-stock-amount').attr('data-variant-code');
        $(this).attr('data-code', finddata).addClass('havecode')
        console.log(finddata)
      }

    })


    $('.availability-value').hide();

    function log(t, e) {
      window.console && (t = void 0 === t ? "test" : t, e = void 0 === e ? "red" : e, console.log("%c%s", "color: white; background: " + e + "; font-size: 20px;", t))
    }


    function exist(t) {
      if ($(t).length) return !0
    } - 1 == window.location.href.indexOf("citybikes.cz") && $(document).ready(function () {

    }), $.fn.hasText = function (t) {
      if (-1 != this.text().indexOf(t)) return !0
    };
    var $html = $("html");

    function sortStocks() {
      $(".Stock").sort(function (t, e) {
        return t.textContent.localeCompare(e.textContent, void 0, {
          numeric: !0,
          sensitivity: "base"
        })
      }).appendTo($(".Stocks"))
    }

    function Stocks(t, e) {
      if (dataLayer[0].shoptet.product.codes)
        for (var o = 0; o < dataLayer[0].shoptet.product.codes.length; o++)
          if (dataLayer[0].shoptet.product.codes[o].code == t) {
            if (dataLayer[0].shoptet.product.codes[o].stocks)
              for (var a = 0; a < dataLayer[0].shoptet.product.codes[o].stocks.length; a++)
                if (StockI = dataLayer[0].shoptet.product.codes[o].stocks[a].id, StockQ = dataLayer[0].shoptet.product.codes[o].stocks[a].quantity, StockCelkem = dataLayer[0].shoptet.product.codes[o].quantity, dataLayer[0].shoptet.stocks)
                  for (var s = 0; s < dataLayer[0].shoptet.stocks.length - 1; s++)
                    if (dataLayer[0].shoptet.stocks[s].id == StockI) {
                      StockNameclass = dataLayer[0].shoptet.stocks[s].title;
                      StockNameclass = StockNameclass.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
                      StockName = dataLayer[0].shoptet.stocks[s].title, $(".Stocks").append('<div class="Stock' + (0 != StockQ ? " inStock" : "") + '" data-pocet="' + StockQ + '"><span class="StockName stonckname-' + StockNameclass + '">' + StockName + ' </span><span class="StockAvail hide">' + StockQ + ("" != e ? ' <span class="varUnit">' + e.split("/")[1].trim() + "</span>" : " ks") + (0 != StockQ ? "" : "") + "</span></div>");
                      break
                    } break
          }
    }
    "productDetail" == getShoptetDataLayer("pageType") && (pkVariants = getShoptetDataLayer("product").hasVariants, Unitvar = $(".pr-list-unit").text(), $(".p-info-wrapper .detail-parameters").after('<div class="Stocks sklady"><div class="eshop hide" data-pocet="">Sklep internetowy</div></div>'), pkVariants ? ($(".Stocks").prepend('<div class="VarInfo">' + $(".p-info-wrapper .availability-value .choose-variant.default-variant").text().trim() + "</div>"), shoptet.scripts.setCustomCallback("shoptet.variantsSimple.switcher", function (t) {
      $(".Stock, .VarInfo").remove(), Codevar = $('.havecode:not(".no-display")').attr('data-code'), Stocks(Codevar, Unitvar), sortStocks()
      $('.eshop').attr('data-pocet', parseInt($('.havecode:not(".no-display") .availability-amount .product-stock-amount').text()))
      $('.eshop').removeClass('hide');
      $('.Stocks div:not(".eshop")').each(function () {
        var findnumber = $(this).attr('data-pocet');
        if (findnumber > 0) {
          $(this).addClass('yes')
        }
      })
      $('.Stocks div.eshop').each(function () {
        var findnumber = $(this).attr('data-pocet');
        if (findnumber == 'NaN') {
          // $(this).html('Tato varianta nenĂ­ dostupnĂˇ').removeClass('yes')
          $(this).html($('.social-buttons-wrapper a.link-icon.chat').clone()).removeClass('yes')
        }
        else {
          $(this).html('Eshop').addClass('yes')
        }

      })
    })) : (Codevar = getShoptetDataLayer("product").code, Stocks(Codevar, Unitvar), sortStocks()));


  }
  else {
    $('.p-info-wrapper .availability-amount .product-stock-amount').each(function () {
      $('.p-info-wrapper .availability-value').hide();
      var findstockpraha = dataLayer[0].shoptet.product.codes[0].stocks[0].quantity;
      var findstockpraha = findstockpraha.replace(/[^\w]/g, '');
      var findstockbrno = dataLayer[0].shoptet.product.codes[0].stocks[1].quantity;
      var findstockbrno = findstockbrno.replace(/[^\w]/g, '');
      var numbertotal = parseInt(findstockpraha) + parseInt(findstockbrno);
      $('.p-info-wrapper').append('<section class="sklady"><div class="eshop" number="' + numbertotal + '">Sklep internetowy</div></section>');
      $.each(dataLayer[0].shoptet.product.codes[0].stocks, function (index, value) {
        $('.p-info-wrapper .sklady').append('<div id-skladu="' + this.id + '" number="' + this.quantity + '"></div>');
      });
      $('.sklady div[id-skladu="3"]').text('Praga');
      $('.sklady div[id-skladu="1"]').text('Brno');
      $('.sklady div').each(function () {
        var findnumber = $(this).attr('number');
        if (findnumber > 0) {
          $(this).addClass('yes')
        }
      })

    });
  }

  if ($('.variant-list').length == 0) {
    $('.availability-value .availability-label').each(function () {
      if ($(this).text().match('Momentálne nedostupné')) {
        $(this).html($('.social-buttons-wrapper a.link-icon.chat').clone().addClass('movelink'))
      }
    })
  }



  $('.p-detail-inner-header h1').clone().appendTo('.p-info-wrapper');
  $('.p-detail-info>.flags').appendTo('.p-image').removeClass('flags-inline');
  $('.p-detail-info').clone().appendTo('.p-info-wrapper');
  $('.p-info-wrapper').append('<div class="kosik flex"></div>')
  $('.p-final-price-wrapper').appendTo('.kosik')
  $('.add-to-cart').appendTo('.kosik');
  if ($('.p-info-wrapper .pr-list-unit').length) {
    var findunit = $('.p-info-wrapper .pr-list-unit').html();
    var findunit = findunit.replace('/', '');
    $('.p-info-wrapper .add-to-cart .quantity').after(findunit);
  }
  if ($('.p-detail-inner-header .p-code').length) {
    $('.extended-description .detail-parameters tr').first().after('<tr><th>Kod produktu:</th><td class="kodporduktu"></td></tr>');
    if ($('.detail-parameters .variant-list').length) {
      $('.p-detail-inner-header .p-code-label').remove();
      $('.kodporduktu').html('Wybierz wariant');
      $('.detail-parameters .variant-list').on('click', function () {
        setTimeout(function () {
          var findkod = $('.p-detail-inner-header .p-code>span:not(".no-display")').html();
          $('.kodporduktu').html(findkod);
        }, 20);
      })

    }
    else {
      var findkod = $('.p-detail-inner-header .p-code>span:not(".p-code-label")').html();
      $('.kodporduktu').html(findkod);

    }
  }

  if ($('.p-info-wrapper a[href*="/znacka/"]').length) {
    var findznacka = $('.product-top>div>.p-detail-info a[href*="/znacka/"]').html();
    //	$('.p-info-wrapper .detail-parameters').append('<tr><th>Výrobce:</th><td>'+findznacka+'</td></tr>');
  }
  $('.extended-description table tr').each(function () {
    if ($(this).text().match('Gwarancja:')) {
      $(this).appendTo('.p-info-wrapper .detail-parameters');
    }
  })



}

if ($('.breadcrumbs-wrapper').length) {
  $('.breadcrumbs-wrapper').removeClass('container').wrapInner('<div class="container"></div>');
}

if ($('.type-category').length) {
  if ($('.category-perex').length) {
    function egurupresuntext() {
      $('<div class="next-cat-perex"></div>').appendTo('main#content')
      $('.category-perex:not(".empty-content") p:not(:first)').appendTo('.next-cat-perex');
    };
    egurupresuntext();
    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
      egurupresuntext();
    });
  }
  if ($('.pagination-loader .load-products').length) {
    var findtext = $('.breadcrumbs>span').last().text().toLowerCase();
    $('.pagination-loader .load-products').text('Zobacz więcej' + findtext);
    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
      var findtext = $('.breadcrumbs>span').last().text().toLowerCase();
      $('.pagination-loader .load-products').text('Zobacz więcej' + findtext);
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
      var findtext = $('.breadcrumbs>span').last().text().toLowerCase();
      $('.pagination-loader .load-products').text('Zobacz więcej' + findtext);
    });

  }

  $('.box-filters').appendTo('main#content');
  function mhfilter() {
    $('label[for="stock"]').text('W magazynie');
    $('body:not(".mobile") #clear-filters').insertAfter('#filters').find('a').text('Wyłącz filtrowanie');
    $('#manufacturer-filter h4').on("click", function () {
      $('#manufacturer-filter').toggleClass('open');
    })
  };
  mhfilter()


  document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    mhfilter();
  });

}


if ($('header#header').length) {
  $('#formSearchForm input').attr('placeholder', 'Czego szukasz?');
  $('.responsive-tools').appendTo('.navigation-buttons');
  $('.navigation-buttons>a.cart-count').appendTo('.responsive-tools');
  $('.top-navigation-bar .dropdown').clone().appendTo('.responsive-tools');
  if ($('.mobile').length) {
    $('.cart-count').removeClass('toggle-window');
    $('.navigation-buttons a[data-target="login"]').attr('href', '/login/').removeClass('toggle-window');
  }
}

if ($('.in-index').length) {
  $('.h4.homepage-group-title').each(function () {
    var findtitle = $(this).text();
    var geturl = findtitle.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\ /g, '-').toLowerCase();
    console.log(geturl);
    var findproduct = $(this).next('.products');
    var textupper = findtitle.toLowerCase();
    $(findproduct).after('<div class="mhnextbutton text-center" title="' + findtitle + '"><a href="/' + geturl + '/" title="' + findtitle + '" class="btn btn-default">Zobacz więcej ' + textupper + '</a></div>');
  })

  /*$('.overeno').appendTo('.homepage-box.welcome-wrapper.welcome-wrapper .welcome');
  if (!sessionStorage.overenohvezdy) {
      $(document).on("ready", function(){
          $(".homepage-box.welcome-wrapper.welcome-wrapper .welcome .overeno p span").load("/hodnoceni-obchodu #ratingWrapper .rate-star-wrap .stars", function(){
            sessionStorage.overenohvezdy = $(".homepage-box.welcome-wrapper.welcome-wrapper .welcome .overeno p span").html();
      });
    })
    } else {
      $(".homepage-box.welcome-wrapper.welcome-wrapper .welcome .overeno p span").append(sessionStorage.overenohvezdy);
    };
    if (!sessionStorage.overenoprocenta) {
      $(document).on("ready", function(){
          $(".homepage-box.welcome-wrapper.welcome-wrapper .welcome .overeno p strong").load("/hodnoceni-obchodu #ratingWrapper .rate-average", function(){
            sessionStorage.overenoprocenta = $(".homepage-box.welcome-wrapper.welcome-wrapper .welcome .overeno p strong").html();
      });
    })
    } else {
      $(".homepage-box.welcome-wrapper.welcome-wrapper .welcome .overeno p strong").append(sessionStorage.overenoprocenta);
    };*/
  $('footer#footer .blog').insertBefore('footer#footer');
  if (!sessionStorage.blog) {
    $(document).on("ready", function () {
      $(".blog .flex-wrap").load("/blog #newsWrapper>div.news-item:lt(2)", function () {
        $('.news-item img').each(function () {
          $(this).attr('src', $(this).attr('data-src'))
        })
        sessionStorage.blog = $(".blog .flex-wrap").html();
      });
    })
  } else {
    $(".blog .flex-wrap").append(sessionStorage.blog);
  };
}

if ($('#formNewsletterWidget input').length) {
  $('#formNewsletterWidget input').attr('placeholder', 'Twój adres e-mailowy')
}

if ($('footer#footer').length) {
  $('footer#footer .prodejnybanner').insertBefore('footer#footer')
  $('#signature').html('Stworzył <a href="https://www.shoptet.cz/?utm_source=footer&utm_medium=link&utm_campaign=create_by_shoptet">Shoptet</a>');
}

if ($('.contact-box').length) {
  $('.contact-box').each(function () {
    var findhere = $(this).find('ul');
    $(findhere).after('<div class="social"></div>');
    var findfacebook = $(this).find('li span.facebook');
    var findyoutube = $(this).find('li span.youtube');
    var findinstagram = $(this).find('li span.instagram');
    if ($(findfacebook).length) {
      $(findfacebook).appendTo('.social')
    }
    if ($(findinstagram).length) {
      $(findinstagram).appendTo('.social')
    }
    if ($(findyoutube).length) {
      $(findyoutube).appendTo('.social')
    }
  });
  if ($('.social').length) {
    $('.social').clone().appendTo('.top-navigation-tools').wrap('<div class="contact-box"></div>');
  }
}


$('.in-index .products-block').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

$(document).ready(function () {
  $('#header .cart-count').attr('style', 'display:flex;');
  $('.top-navigation-contacts').attr('style', 'position:initial;right:unset;')
})

if ($("#p-detail-tabs").length) {
  $('#p-detail-tabs > li:last-child').after('<li class="shp-tab"><a href="#jak_vybrat_kolo" class="shp-tab-link" role="tab" data-toggle="tab">Jak wybrać rower</a></li>'),
    $('#tab-content > div:last-child').after('<div id="jak_vybrat_kolo" class="tab-pane fade" role="tabpanel" />');
  $('#p-detail-tabs > li:last-child').after('<li class="shp-tab"><a href="#tabulky_velikosti" class="shp-tab-link" role="tab" data-toggle="tab">Tabele rozmiarów</a></li>'),
    $('#tab-content > div:last-child').after('<div id="tabulky_velikosti" class="tab-pane fade" role="tabpanel" />');
  $.ajax({
    type: "POST",
    url: "/vyber-spravneho-bicykla/",
    success: function (content) {
      var listing = $(content).find('div[itemprop="about"]');

      if (listing !== null) {
        $('#jak_vybrat_kolo').html(listing);
      }
      $.post(window.location.href, function (data) { });
    }
  });

  $.ajax({
    type: "POST",
    url: "/informace/tabulky-velikosti/",
    success: function (content) {
      var listing = $(content).find('div.content-inner div.text');

      if (listing !== null) {
        $('#tabulky_velikosti').html(listing);
      }
      $.post(window.location.href, function (data) { });
    }
  });
};

if ($('.products.products-page').length) {
  $(document).on("ready ShoptetDOMContentLoaded", function () {
    $('.product').each(function () {
      var finddostupnost = $(this).find('.availability>span:not(".availability-amount")').text()
      console.log(finddostupnost)
      var finddostupnost = finddostupnost.normalize('NFD').replace(/[^\w]/g, '').toLowerCase()
      $(this).addClass(finddostupnost)
      discount = $(this).find('.flag.flag-discount')
      if ($(discount).length > 0) {
        $(this).find('.p-bottom .prices').prepend($(this).find('.flag.flag-discount').clone())
      }
    })
  })

}